import Breadcrumbs from "@atoms/breadcrumbs/Breadcrumbs";
import { Breadcrumb } from "@atoms/breadcrumbs/Breadcrumbs.types";
import Typography from "@atoms/typography/Typography";
import { gridStyles } from "@layout/grid";
import { cn, tw } from "@utils/tailwind";
import Link from "next/link";
import { FC } from "react";

const rootStyles = tw`group
  block
  border-t
  border-grey-scale-light-gray
  py-6
  text-content-primary-on-light
  outline-none
  transition-colors
  duration-300
  ease-out
  hover:bg-grey-light
  focus:bg-grey-light
  md:py-8
  lg:py-9
  xl:py-10
  [&_em]:font-bold
  [&_em]:not-italic`;

const underlineStyles = tw`text-content-primary-on-light
  underline
  decoration-transparent
  decoration-2
  underline-offset-4
  transition-colors
  duration-300
  ease-out
  lg:group-hover:decoration-current
  lg:group-focus:decoration-current`;

export type HitData = {
  id: string;
  title: string;
  content: string;
  link: string;
  breadcrumbs: Breadcrumb[];
};

export type HitProps = {
  data: HitData;
  isFetching: boolean;
};

export const Hit: FC<HitProps> = ({ data, isFetching }) => (
  <Link href={data.link} className={rootStyles}>
    <div className={cn(gridStyles.container, isFetching && "animate-pulse")}>
      <div
        className={cn(
          gridStyles.itemShrinked,
          "min-w-0" // it fixes breadcrumbs overflow
        )}
      >
        <Breadcrumbs
          parts={data.breadcrumbs}
          className="mb-6 py-1 text-xs tracking-[0.02em] text-grey-mid xl:mb-7"
        />
        <p
          className={cn(
            underlineStyles,
            "font-termina text-lg font-medium md:text-xl lg:text-2xl xl:text-3xl"
          )}
          dangerouslySetInnerHTML={{ __html: data.title }}
        />
        <Typography
          tag="p"
          variant="base"
          className="mt-2 max-h-[6.25rem] overflow-hidden md:mt-3 md:max-h-20 lg:max-h-[3.25rem] xl:max-h-14"
          dangerouslySetInnerHTML={{ __html: data.content }}
        />
      </div>
    </div>
  </Link>
);
